import { useContext, useState, useEffect } from '@wordpress/element';
import { Table, Input } from 'semantic-ui-react';
import UserContext from '../context/context';

const Tables = () => {
    const context = useContext(UserContext);
    const { data } = context;
    const [metroArea, setMetroArea] = useState(data);
    const [noResultsFound, setNoResultsFound] = useState(false);

    const searchTable = e => {
        const query = e.target.value.toLowerCase().trim();
        if ('' === query) {
            setMetroArea(data);
        } else {
            const array = [];
            data.map(v => {
                Object.keys(v).map(k => {
                    if ('msa_code' !== k) {
                        const item = v[k].toString().toLowerCase();
                        if (item.includes(query)) {
                            array.push(v);
                        }
                    }
                });
            });
            setMetroArea(array);
            if (0 === array.length) {
                setNoResultsFound(true);
            }
        }
    };

    useEffect(() => {
        setMetroArea(data);
    }, [data]);

    return (
        <>
            <div className="title_div">
                <h4>
                    Share of newlyweds with a spouse of a different race or
                    ethnicity, by metropolitan area (2011-2015)
                </h4>
            </div>
            <Input placeholder="Search..." onChange={e => searchTable(e)} />
            <div id="percent_header">% intermarried among</div>
            <div id="table">
                <Table width="100%" unstackable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell className="all">
                                Metro area
                            </Table.HeaderCell>
                            <Table.HeaderCell className="all">
                                Total % intermarried
                            </Table.HeaderCell>
                            <Table.HeaderCell className="min-tablet-p">
                                Whites
                            </Table.HeaderCell>
                            <Table.HeaderCell className="min-tablet-p">
                                Blacks
                            </Table.HeaderCell>
                            <Table.HeaderCell className="min-tablet-p">
                                Hispanics
                            </Table.HeaderCell>
                            <Table.HeaderCell className="min-tablet-p">
                                Asians
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        <Table.Row className="fixed-row">
                            <Table.Cell>United States</Table.Cell>
                            <Table.Cell>16</Table.Cell>
                            <Table.Cell className="min-tablet-p">10</Table.Cell>
                            <Table.Cell className="min-tablet-p">18</Table.Cell>
                            <Table.Cell className="min-tablet-p">26</Table.Cell>
                            <Table.Cell className="min-tablet-p">29</Table.Cell>
                        </Table.Row>
                        {metroArea &&
                            metroArea.map((row, index) => {
                                return (
                                    <Table.Row>
                                        <Table.Cell>
                                            {row.metro_name}
                                        </Table.Cell>
                                        <Table.Cell>{row.total}</Table.Cell>
                                        <Table.Cell className="min-tablet-p">
                                            {row.whites}
                                        </Table.Cell>
                                        <Table.Cell className="min-tablet-p">
                                            {row.blacks}
                                        </Table.Cell>
                                        <Table.Cell className="min-tablet-p">
                                            {row.hisps}
                                        </Table.Cell>
                                        <Table.Cell className="min-tablet-p">
                                            {row.asians}
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            })}
                        {noResultsFound && (
                            <Table.Row className="even">
                                <Table.Cell
                                    valign="top"
                                    colspan="6"
                                    className="dataTables_empty"
                                >
                                    No Results were Found
                                </Table.Cell>
                            </Table.Row>
                        )}
                    </Table.Body>
                </Table>
            </div>
        </>
    );
};

export default Tables;
